import create from "zustand/vanilla";

export const store = create(() => ({
    addons: {},
}));
